export default async function EditUserApi(id, email, employeeId, hourlyRate, empReferrenceId, whatsappNumber) {
  let res = "";
  try {
    const body = {
      id: id,
      email: email,
      employeeId: employeeId,
      hourlyRate: hourlyRate,
      empReferrenceId: empReferrenceId,
      whatsappNumber: whatsappNumber ?? null,
    };
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/users/`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error add user: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
